import PropTypes from 'prop-types';
import classnames from 'classnames';
import React from 'react';
import Money from '../../../../common/money';

const ChairRentalAmount = ({ amount, color, onClick, className }) => {
  const colorClass = classnames('c-chair-rental-data', {
    'c-chair-rental-data--green': color === 'green',
    'c-chair-rental-data--red': color === 'red',
  }, className);

  const isValidAmount = amount !== null;

  const opts = {};
  if (isValidAmount) {
    opts.onClick = onClick;
  }

  return (
    <div className={colorClass} {...opts}>
      <span className="u-align-middle">
        {isValidAmount ? <Money>{amount}</Money> : '-'}
      </span>
    </div>
  );
};

ChairRentalAmount.propTypes = {
  color: PropTypes.string,
  amount: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

ChairRentalAmount.defaultProps = {
  color: '',
  amount: null,
  onClick: null,
  className: '',
};

export default ChairRentalAmount;
